<template>
  <div class="relation-page">
    <div class="relation-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="relation-page-navigate-body  position-relative">
        <div class="relation-page-navigate-body-content safe-with">
          <p class="font-bold font-36 font-color-fff">关系图谱</p>
        </div>
      </div>
    </div>
    <div class="relation-page-body safe-with">
      <div class="relation-page-body-tools flex-row-center">
        <span class="relation-page-body-tools-item">
          <el-select v-model="deepValue" placeholder="请选择" @change="deepValueChange">
            <el-option
              v-for="item in deepOpt"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </span>
        <span class="relation-page-body-tools-item">
          <el-select v-model="typeValue" multiple collapse-tags placeholder="请选择" @change="typeValueChange">
            <el-option
              v-for="item in typeOpt"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </span>
      </div>
      <!-- <div id="relation-page-body-echar" style="height: 100%;" /> -->
      <relation-graph ref="rg" :options="graphOptions">
        <div slot="node" slot-scope="{node}">
          <el-popover
            width="200"
            placement="right"
            trigger="hover"
          >
            <div
              slot="reference"
              style="border-radius: 50%;cursor: pointer; overflow: hidden;border: 3px solid #EBEEF5;"
              class="flex-column-center position-relative"
              :style="{width: (node.width)+'px',height: node.height+'px',borderColor:node.color}"
            >
              <el-image class="node-img" :src="'http://img.libraryplus.bjadks.com/'+node.data.image" style="border-radius: 50%;border-width: 3px; user-select: none;" :style="{width: node.data.size+'px',height: node.data.size+'px'}" />
              <div class="linear" :style="{height:parseInt(node.data.size)/2+'px',width:node.data.size+'px'}" style="position: absolute;bottom: 0">
                <span class="text-line1" :style="{lineHeight:parseInt(node.data.size)/2+'px'}" style="color: #FFFFFF;overflow: hidden">{{ node.text }}</span>
              </div>
            </div>
            <el-card shadow="never" style="border: none!important;">
              <el-form v-if="node.type=='person'" size="small" label-suffix=":">
                <el-form-item v-if="node.text" label="姓名">
                  {{ node.text }}
                </el-form-item>
                <el-form-item v-if="node.data.sex" label="性别">
                  {{ node.data.sex }}
                </el-form-item>
                <el-form-item v-if="node.data.bronDate" label="出生年月">
                  {{ node.data.bronDate }}
                </el-form-item>
                <el-form-item v-if="node.data.nativePlace" label="籍贯">
                  {{ node.data.nativePlace }}
                </el-form-item>
                <el-form-item v-if="node.data.description" label="人物简介">
                  {{ node.data.description }}
                </el-form-item>
              </el-form>
              <el-form v-else-if="node.type=='event'" size="small" label-suffix=":">
                <el-form-item v-if="node.text" label="名称">
                  {{ node.text }}
                </el-form-item>

                <el-form-item v-if="node.data.startDate" label="发生地点">
                  {{ node.data.coordinate }}
                </el-form-item>
                <el-form-item label="大事件">
                  {{ node.data.majorEvent?'是':'否' }}
                </el-form-item>
                <el-form-item label="时间轨迹">
                  {{ node.data.trajectory?'是':'否' }}
                </el-form-item>
                <el-form-item v-if="node.data.startDate" label="开始时间">
                  {{ node.data.startDate }}
                </el-form-item>
                <el-form-item v-if="node.data.endDate" label="开始时间">
                  {{ node.data.endDate }}
                </el-form-item>
                <el-form-item v-if="node.data.description" label="时间描述">
                  {{ node.data.description }}
                </el-form-item>
              </el-form>
              <el-form v-else-if="node.type=='place'" size="small" label-suffix=":">
                <el-form-item v-if="node.text" label="名称">
                  {{ node.text }}
                </el-form-item>
                <el-form-item v-if="node.data.coordinate" label="地址">
                  {{ node.data.coordinate }}
                </el-form-item>
                <el-form-item v-if="node.data.mapPlace" label="坐标">
                  {{ node.data.mapPlace }}
                </el-form-item>

                <el-form-item v-if="node.data.description" label="地点描述">
                  {{ node.data.description }}
                </el-form-item>
              </el-form>
              <el-form v-else-if="node.type=='organization'" size="small" label-suffix=":">
                <el-form-item v-if="node.text" label="名称">
                  {{ node.text }}
                </el-form-item>

                <el-form-item v-if="node.data.place" label="地点">
                  {{ node.data.place }}
                </el-form-item>

                <el-form-item v-if="node.data.description" label="机构描述">
                  {{ node.data.description }}
                </el-form-item>
              </el-form>
            </el-card>
          </el-popover>
        </div>
      </relation-graph>
    </div>
  </div>
</template>

<script>
// import * as echarts from 'echarts'
import RelationGraph from 'relation-graph'
import api from '@/api/index.js'
export default {
  components: {
    RelationGraph
  },
  data() {
    return {
      graphOptions: {
        disableDragNode: false,
        defaultNodeFontColor: '#fff',
        allowShowMiniToolBar: false,
        backgroundColor: '#162336'
      },
      deepOpt: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }],
      deepValue: '2',
      typeOpt: [{
        value: 'person',
        label: '人物'
      }, {
        value: 'event',
        label: '事件'
      }, {
        value: 'organization',
        label: '机构'
      }, {
        value: 'place',
        label: '地点'
      }],
      typeValue: [],
      nodes: [],
      relations: []
    }
  },
  created() {
    this.request()
  },
  methods: {
    async request() {
      const res = await api.nodeRelation({
        direction: 0,
        startId: 1,
        level: this.deepValue,
        endLabel: this.typeValue.join(',')
      })
      const node = []
      res.items.nodes.forEach(item => {
        const name = {
          id: item.id + '',
          text: item.property.name,
          color: item.property.color,
          borderColor: item.property.color,
          data: item.property,
          type: item.label[0],
          height: parseInt(item.property.size) + 3,
          width: parseInt(item.property.size) + 3
        }
        node.push(name)
      })
      this.nodes = node

      const relation = []
      res.items.relations.forEach(item => {
        const name = {
          from: item.startId + '',
          to: item.endId + '',
          text: item.typeName + '',
          color: item.property.color,
          lineWidth: item.property.lineWidth,
          // 'useTextPath': true,
          'isHideArrow': false,
          'showStartArrow': false,
          'showEndArrow': true,
          data: item.property,
          lineShape: 5

        }
        relation.push(name)
      })
      this.relations = relation
      this.setGraphData()
    },
    setGraphData() {
      if (this.nodes.length === 0) {
        return
      }
      const relation_graph = { 'rootId': 'id', nodes: this.nodes, lines: this.relations }
      console.log('关系图', relation_graph)
      this.$refs.rg.setJsonData(relation_graph, (graphInstance) => {
        // 这些写上当图谱初始化完成后需要执行的代码
      })
    },
    deepValueChange(v) {
      this.request()
    },
    typeValueChange(v) {
      this.request()
    }
    // initEcharts() {
    //   const data = {
    //     nodes: [{
    //       name: '操作系统集团',
    //       category: 0
    //     }, {
    //       name: '浏览器有限公司',
    //       category: 0
    //     }, {
    //       name: 'HTML科技',
    //       category: 0
    //     }, {
    //       name: 'JavaScript科技',
    //       category: 0
    //     }, {
    //       name: 'CSS科技',
    //       category: 0
    //     }, {
    //       name: 'Chrome',
    //       category: 1
    //     }, {
    //       name: 'IE',
    //       category: 1
    //     }, {
    //       name: 'Firefox',
    //       category: 1
    //     }, {
    //       name: 'Safari',
    //       category: 1
    //     }],

    //     links: [{
    //       source: '浏览器有限公司',
    //       target: '操作系统集团',
    //       name: '参股'
    //     }, {
    //       source: 'HTML科技',
    //       target: '浏览器有限公司',
    //       name: '参股'
    //     }, {
    //       source: 'CSS科技',
    //       target: '浏览器有限公司',
    //       name: '参股'
    //     }, {
    //       source: 'JavaScript科技',
    //       target: '浏览器有限公司',
    //       name: '参股'
    //     }, {
    //       source: '浏览器有限公司',
    //       target: 'Chrome',
    //       name: '董事'
    //     }, {
    //       source: 'IE',
    //       target: '浏览器有限公司',
    //       name: '董事'
    //     }, {
    //       source: 'Firefox',
    //       target: '浏览器有限公司',
    //       name: '董事'
    //     }, {
    //       source: 'Safari',
    //       target: '浏览器有限公司',
    //       name: '董事'
    //     }, {
    //       source: 'Chrome',
    //       target: 'JavaScript科技',
    //       name: '法人'
    //     }]
    //   }

    //   const color1 = '#006acc'
    //   const color2 = '#ff7d18'
    //   const color3 = '#10a050'

    //   data.nodes.forEach(node => {
    //     if (node.category === 0) {
    //       node.symbolSize = 100
    //       node.itemStyle = {
    //         color: color1
    //       }
    //     } else if (node.category === 1) {
    //       node.itemStyle = {
    //         color: color2
    //       }
    //     }
    //   })

    //   data.links.forEach(link => {
    //     link.label = {
    //       align: 'center',
    //       fontSize: 12
    //     }

    //     if (link.name === '参股') {
    //       link.lineStyle = {
    //         color: color2
    //       }
    //     } else if (link.name === '董事') {
    //       link.lineStyle = {
    //         color: color1
    //       }
    //     } else if (link.name === '法人') {
    //       link.lineStyle = {
    //         color: color3
    //       }
    //     }
    //   })

    //   const categories = [{
    //     name: '公司',
    //     itemStyle: {
    //       color: color1
    //     }
    //   },
    //   {
    //     name: '董事',
    //     itemStyle: {
    //       color: color2
    //     }
    //   }]
    //   var chartDom = document.getElementById('relation-page-body-echar')
    //   var myChart = echarts.init(chartDom)
    //   var option = option = {
    //     title: {
    //       text: ''
    //     },
    //     legend: [{
    //       // selectedMode: 'single',
    //       data: categories.map(x => x.name)
    //       // icon: 'circle'
    //     }],
    //     series: [{
    //       tooltip: {},
    //       type: 'graph',
    //       layout: 'force',
    //       symbolSize: 58,
    //       draggable: true,
    //       roam: true,
    //       focusNodeAdjacency: true,
    //       categories: categories,
    //       edgeSymbol: ['', 'arrow'],
    //       // edgeSymbolSize : [80, 10],
    //       edgeLabel: {
    //         normal: {
    //           show: true,
    //           textStyle: {
    //             fontSize: 20
    //           },
    //           formatter(x) {
    //             return x.data.name
    //           }
    //         }
    //       },
    //       label: {
    //         show: true
    //       },
    //       force: {
    //         repulsion: 2000,
    //         edgeLength: 120
    //       },
    //       data: data.nodes,
    //       links: data.links
    //     }]
    //   }
    //   option && myChart.setOption(option)
    // }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input__select {
  height: 30px;
}
  /deep/.el-input__inner {
    width: 140px;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border: none;
  }
</style>

<style scoped>
  .relation-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .relation-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .relation-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .relation-page-navigate-body-content {
    padding-top: 120px;
  }

  .relation-page-navigate-body-content p {
    line-height: 80px;
  }

  .relation-page-body {
    height: 700px;
    background: #162336;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 60px;
    position: relative;
  }

  .relation-page-body-tools {
    padding: 10px;
    position: absolute;
    z-index: 9999;
  }

  .relation-page-body-tools-item {
    margin-right: 20px;
  }

  .node-img {
    pointer-events: none;
  }
</style>

<style lang="scss" scoped>
  /deep/.relation-graph .rel-map {
    border-radius: 5px;
  }
  /deep/.el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
    line-height: 25px;
  }
  /deep/.el-form-item--small .el-form-item__label {
    line-height: 25px;
  }

  /deep/.el-card__body {
    padding: 0;
  }
</style>
